/* Gretchen Masonry Heaters — shop.js
   Client-side filter + sort for the Collection page.
   Pure DOM. No framework. */

(function () {
  "use strict";

  const state = { kind: "all", volume: "all", sort: "price-asc" };

  const cards = Array.from(document.querySelectorAll(".heater-card[data-kind]"));
  const groups = Array.from(document.querySelectorAll(".shop-group[data-group]"));
  const resultEl = document.querySelector("[data-result-count]");

  if (!cards.length) return;

  function inVolumeBand(m3, band) {
    if (band === "all") return true;
    if (band === "small") return m3 <= 250;
    if (band === "medium") return m3 > 250 && m3 < 650;
    if (band === "large") return m3 >= 650;
    return true;
  }

  function apply() {
    // Filter
    const matches = new Set();
    for (const card of cards) {
      const kind = card.dataset.kind;
      const m3 = parseInt(card.dataset.m3, 10);
      const kindOk = state.kind === "all" || state.kind === kind;
      const volOk = inVolumeBand(m3, state.volume);
      const show = kindOk && volOk;
      card.hidden = !show;
      if (show) matches.add(card);
    }

    // Sort within each group
    for (const group of groups) {
      const grid = group.querySelector(".shop-grid");
      if (!grid) continue;
      const visible = Array.from(grid.children).filter((c) => !c.hidden);
      visible.sort((a, b) => {
        if (state.sort === "price-asc") return +a.dataset.price - +b.dataset.price;
        if (state.sort === "price-desc") return +b.dataset.price - +a.dataset.price;
        if (state.sort === "m3-desc") return +b.dataset.m3 - +a.dataset.m3;
        return 0;
      });
      visible.forEach((el) => grid.appendChild(el));

      // Hide entire group if no matches in it
      group.hidden = visible.length === 0;
      const count = group.querySelector("[data-group-count]");
      if (count) count.textContent = `${visible.length} model${visible.length === 1 ? "" : "s"}`;
    }

    if (resultEl) {
      resultEl.textContent = `${matches.size} of ${cards.length}`;
    }
  }

  // Chip behavior
  document.querySelectorAll(".shop-filters .chip[data-filter]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const filter = btn.dataset.filter;
      const value = btn.dataset.value;
      state[filter] = value;
      document
        .querySelectorAll(`.shop-filters .chip[data-filter="${filter}"]`)
        .forEach((b) => b.setAttribute("aria-pressed", String(b === btn)));
      apply();
    });
  });

  document.querySelectorAll(".shop-filters .chip[data-sort]").forEach((btn) => {
    btn.addEventListener("click", () => {
      state.sort = btn.dataset.sort;
      document
        .querySelectorAll(".shop-filters .chip[data-sort]")
        .forEach((b) => b.setAttribute("aria-pressed", String(b === btn)));
      apply();
    });
  });

  apply();
})();
